var map = {
	"./Icon-3-06.png": "503a",
	"./Icons-2-01-01.png": "9d6f",
	"./POS-QR.png": "ccdc",
	"./POS-money.png": "ac70",
	"./QR-code.png": "8826",
	"./aadhar_card.png": "7cb7",
	"./bank_statement.png": "d2e9",
	"./battery.png": "6283",
	"./business_license.png": "4c31",
	"./business_photos.png": "2fca",
	"./card.png": "9adf",
	"./cards.png": "fc4b",
	"./digital-mobile.png": "72ab",
	"./edi.png": "5e04",
	"./ftpay-link.png": "ba9e",
	"./low-interest.png": "57d3",
	"./mini-home.png": "9e93",
	"./mini-mobile.png": "d369",
	"./money.png": "2552",
	"./pan_card.png": "58b0",
	"./paperless.png": "bbb6",
	"./property_docs.png": "af6b",
	"./wifi.png": "9dee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";